import React, { useEffect ,useState} from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Paper from '@material-ui/core/Paper';
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'
import Chip from '@material-ui/core/Chip';
import BeatLoader from "react-spinners/BeatLoader";
import DoneOutlineRoundedIcon from '@material-ui/icons/DoneOutlineRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import HourglassEmptyRoundedIcon from '@material-ui/icons/HourglassEmptyRounded';
import { green,orange,red } from '@material-ui/core/colors';
import SvgIcon from '@material-ui/core/SvgIcon';
const useStyles = makeStyles(styles);

export default function History(props) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  let [loading, setLoading] = useState(true);
  let [scoreSubtotal, setScoreSubtotal] = useState(true);


  useEffect(() => {
    Axios.post(Config.api + "Product/GetUserProducts", {
      order:props.order?props.order:"ASC"
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        setLoading(false)
        setRows(result.data.data)
        setScoreSubtotal(subtotal(result.data.data))
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
        else if (err && err.response && err.response.data && err.response.data.fa_message) {
          swal(err.response.data.fa_message);
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  },[])
  function subtotal(items) {
    return items.map(({ siteScore }) => siteScore?siteScore:0).reduce((sum, i) => sum + i, 0);
  }
  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined"  >
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    {props.title?props.title:"سوابق حضور"} 
                          </Typography>
    <TableContainer className={classes.tableContainer} >
    <div className={classes.center + " " + classes.fastAccess}>
                  <BeatLoader loading={loading} color={"gray"} size={15} />
                </div>
{!loading?(



      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell >عنوان</TableCell>
            <TableCell >تاریخ برگزاری</TableCell>
            <TableCell align="center">وضعیت ثبت نام</TableCell>
            <TableCell align="center">رتبه / نمره</TableCell>
            <TableCell align="center">امتیاز</TableCell>
          </TableRow>
          
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row" >
                {row.title}
              </TableCell>
              <TableCell>{row.heldAt}</TableCell>
              <TableCell align="center">{row.registerStatus?
              <Chip icon={<DoneOutlineRoundedIcon style={{ color: green[500] }} />} label="تایید شده" />
              :row.registerStatus==null?
              <Chip icon={<HourglassEmptyRoundedIcon style={{ color: orange[500] }} />} label="در انتظار" />
              :
              <Chip icon={<CloseRoundedIcon style={{ color: red[500] }} />} label="تایید نشده" />
              }</TableCell>
              <TableCell align="left">{row.rankOrScore?(row.rankType==0?"نمره ":row.rankType==1?"رتبه ":"")+row.rankOrScore+ " از "+row.total:"-"}</TableCell>
              <TableCell className={classes.en + " " +classes.green}  align="center"> {row.siteScore?"+"+row.siteScore:""}</TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell rowSpan={3}  colSpan={3}/>
            <TableCell  align="center" colSpan={1}>جمع امتیاز</TableCell>
            <TableCell align="center"><b>{scoreSubtotal}</b></TableCell>
          </TableRow>
        </TableBody>
      </Table>
      ):
      null}
    </TableContainer>

                  </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>
      </GridContainer>
    </form>
  );
}